<ion-app>
    <div id="app" [ngClass]="{'theme-dark': processor.isDarkMode$ | async}">
        <!-- Left panel with cover effect-->
        <div class="panel panel-left panel-cover panel-init theme-dark">
            <div class="view">
                <div class="page">
                    <div class="navbar">
                        <div class="navbar-bg"></div>
                        <div class="navbar-inner">
                            <div class="left">
                                <a class="link panel-close">
                                    <i class="icon icon-back"></i>
                                    <span class="if-not-md">Close</span>
                                </a>
                            </div>
                            <div class="title">Smart-BOT</div>
                        </div>
                    </div>
                    <div class="page-content">
                        <div class="list media-list user-menu-item">
                            <ul>
                                <li class="item-link" (click)="gotoAccount()">
                                    <div class="item-content">
                                        <div class="item-media">
                                            <div style="width: 44px; height: 44px; border-radius: 50%; background-image: url({{account?.Avatar?.SmallImage}}); background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
                                        </div>
                                        <div class="item-inner">
                                            <div class="item-title-row">
                                                <div class="item-title">{{account.Name}}</div>
                                            </div>
                                            <div class="item-subtitle text-color-gray">{{account?.Core?.Domain || 'unknown'}}</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <!-- Menu -->
                        <div class="block-title">MENU</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/accounting/dashboard')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Main Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End Menu -->

                        <!-- CTV Bán Hàng -->
                        <div class="block-title">CTV Bán Hàng</div>
                        <div class="list">
                            <ul>
                                <!--<li>
                                    <a href="#" (click)="goto('/collaborator/dashboard')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>-->
                                <li>
                                    <a href="#" class="item-link item-content" (click)="goto('/collaborator/order-list')">
                                        <div class="item-media"><i class="icon f7-icons">bag</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Đơn hàng
                                                <div class="item-footer">Order</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content" (click)="goto('/collaborator/opportunity-list')">
                                        <div class="item-media"><i class="icon f7-icons">question_diamond</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Cơ hội bán hàng
                                                <div class="item-footer">Sales opportunity</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content" (click)="goto('/collaborator/customer-list')">
                                        <div class="item-media"><i class="icon f7-icons">person_alt_circle</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                DS Khách hàng
                                                <div class="item-footer">Customer list</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content" (click)="goto('/collaborator/publisher-list')">
                                        <div class="item-media"><i class="icon f7-icons">person_circle</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                DS Cộng Tác Viên
                                                <div class="item-footer">Publisher list</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <!--<li>
                                    <a href="#" class="item-link item-content" (click)="goto('/collaborator/product-list/multichoose')">
                                        <div class="item-media"><i class="icon f7-icons">cube</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                SP CTV
                                                <div class="item-footer">Dánh sản phẩm kinh doanh</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>-->
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_circle</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Báo cáo của tôi
                                                <div class="item-footer">My reports</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_pie</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dành cho Leader
                                                <div class="item-footer">Leader space</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">person_crop_circle_badge_xmark</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Chặn CTV
                                                <div class="item-footer">Block publisher</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">person_crop_circle_badge_checkmark</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phân quyền quản lý CTV
                                                <div class="item-footer">Grant permission</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">heart_circle</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Chăm sóc CTV
                                                <div class="item-footer">Publisher list</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">square_favorites_alt</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Chiết khấu
                                                <div class="item-footer">Commission</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">gift</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Thưởng
                                                <div class="item-footer">Award</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">rocket</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Tăng cường
                                                <div class="item-footer">Advance task</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">star_circle</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Đánh giá của KH
                                                <div class="item-footer">Customer rating</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">gear_alt</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Cài đặt KPIs/OKRs
                                                <div class="item-footer">Setup KPIs/OKRs</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                                <!-- <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Đối soát
                                                <div class="item-footer">Đối soát</div>
                                            </div>
                                        </div>
                                    </a>
                                </li> -->
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- CTV Bán Hàng -->
                        <div class="block-title">Quản lý hợp đồng</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#"  (click)="goto('/contract/contract-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">doc_text_fill</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Hợp đồng
                                                <div class="item-footer">Contracts</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <!-- Deoployment -->
                        <div class="block-title">Triển Khai</div>
                        <div class="list">
                            <ul>
                                <!--<li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>-->
                                <li>
                                    <a href="#" (click)="goto('/deployment/voucher-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiếu triển khai
                                                <div class="item-footer">Phiếu triển khai</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- Commerce POS -->
                        <div class="block-title">POS Thương mại</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/commerce-pos/dashboard')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">POS Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/commerce-pos/order-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">bag</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Đơn hàng
                                                <div class="item-footer">POS - Orders</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/commerce-pos/gui/new')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">sidebar_right</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Máy bán hàng
                                                <div class="item-footer">POS - Point Of Sales</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- Sales -->
                        <div class="block-title">Bán hàng</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/sales/dashboard')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Sales Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/sales/goods-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">doc_text_search</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Bảng giá gốc
                                                <div class="item-footer">Master price table</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/sales/price-report-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">square_favorites</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiếu báo giá
                                                <div class="item-footer">Quotation</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/sales/price-report-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">square_favorites</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiếu bán hàng
                                                <div class="item-footer">Selling vouchers</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/sales/master-price-table-update-note-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">doc</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiếu cập nhật giá
                                                <div class="item-footer">Phiếu cập nhật giá</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- Purchase -->
                        <div class="block-title">Thu mua</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/purchase/dashboard')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Purchase Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/purchase/product-list/preview')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">cube</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Hàng hóa
                                                <div class="item-footer">Xem giá nhập</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" (click)="goto('/purchase/price-statistics')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phân tích giá nhập
                                                <div class="item-footer">Price Statistics</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/purchase/purchase-order-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">cart</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiếu đặt hàng
                                                <div class="item-footer">Purchase order</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">cube_box</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiếu mua hàng
                                                <div class="item-footer">Purchase</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a class="item-link item-content" (click)="processor.scan2PO()">
                                        <div class="item-media"><i class="icon f7-icons">barcode_viewfinder</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Quét mã đặt hàng
                                                <div class="item-footer">Scan to PO</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- Warehouse -->
                        <div class="block-title">Kho bãi</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/warehouse/dashboard')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Warehouse Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/warehouse/goods-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">cube</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Hàng hóa
                                                <div class="item-footer">Goods</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/warehouse/goods-queue')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">square_stack_3d_down_right</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Hàng đợi
                                                <div class="item-footer">Goods queue</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/warehouse/goods-receipt-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">tray_arrow_down</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Nhập kho
                                                <div class="item-footer">Goods receipt</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/warehouse/goods-delivery-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">tray_arrow_up</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Xuất kho
                                                <div class="item-footer">Goods delivery</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/warehouse/inventory-adjust-note-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">text_badge_checkmark</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Kiểm kho
                                                <div class="item-footer">Inventory adjust</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/warehouse/goods-container-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">archivebox</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Vị trí hàng hóa
                                                <div class="item-footer">Goods container</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- Admin Product -->
                        <div class="block-title">Thông tin sản phẩm</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/admin-product/dashboard')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Product Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="goto('/admin-product/product-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">cube_box</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Quản lý sản phẩm
                                                <div class="item-footer">Admin Product</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- Admin Product -->
                        <div class="block-title">Thông tin liên hệ</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" class="item-link item-content" (click)="goto('/contact/contact-list')">
                                        <div class="item-media"><i class="icon f7-icons">person_alt_circle</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Liên hệ
                                                <div class="item-footer">Dannh sách liên hệ</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- Accounting -->
                        <div class="block-title">Kế toán</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/accounting/dashboard')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Accounting Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" (click)="goto('/accounting/receipt-voucher-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">doc_plaintext</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiếu thu
                                                <div class="item-footer">Receipt</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" (click)="goto('/accounting/payment-voucher-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">doc_plaintext</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiếu chi
                                                <div class="item-footer">Payment</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">doc_append</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Báo cáo công nợ
                                                <div class="item-footer">Debt report</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- B2B -->
                        <!-- <div class="block-title">Sàn Bán Sỉ ProBox.vn</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">chart_bar_square</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Dashboard
                                                <div class="item-footer">Dashboard</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">sidebar_right</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Máy bán hàng
                                                <div class="item-footer">POS - Point Of Sales</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Đồng bộ mã hàng
                                                <div class="item-footer">Sku Synchronous</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Đơn hàng đến
                                                <div class="item-footer">Incomming orders</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Đơn hàng đi
                                                <div class="item-footer">Outgoing orders</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Tham khảo mã hàng
                                                <div class="item-footer">Consult</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Công nợ
                                                <div class="item-footer">Debt</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Theo dõi vận chuyển
                                                <div class="item-footer">Delivery monitoring</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div> -->
                        <!-- End -->

                        <!-- Tools -->
                        <div class="block-title">CÔNG CỤ/TOOLS</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a (click)="processor.scanQRCode()" href="#" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">qrcode_viewfinder</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Quét mã
                                                <div class="item-footer">QR Code, Bar Code</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->

                        <!-- Pbx Menu -->
                        <div class="block-title">Tổng đài ảo</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/pbx/extension-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Số mở rộng
                                                <div class="item-footer">Extension</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" (click)="goto('/pbx/call-log-list')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Nhật ký cuộc gọi
                                                <div class="item-footer">Call logs</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End Pbx Menu -->

                        <!-- Email menu -->
                        <div class="block-title">Email</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" (click)="goto('/mail-client/inbox')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Hộp thư đến
                                                <div class="item-footer">Inbox</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" (click)="goto('/mail-client/sent')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Đã gửi
                                                <div class="item-footer">Sent</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="#" (click)="goto('/mail-client/junk')" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">app</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Thư rác
                                                <div class="item-footer">Junk</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End Email menunu -->

                        <!-- System -->
                        <div class="block-title">HỆ THỐNG/SYSTEM</div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a (click)="gotoToSettings()" class="item-link item-content panel-close">
                                        <div class="item-media"><i class="icon f7-icons">gear</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Cài đặt
                                                <div class="item-footer">Settings</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="gotoAbout()" class="item-link item-content" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">info_circle</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Giới thiệu
                                                <div class="item-footer">About</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a (click)="processor.checkUpdate($event)" class="item-link item-content">
                                        <div class="item-media"><i class="icon f7-icons">tag</i></div>
                                        <div class="item-inner">
                                            <div class="item-title">
                                                Phiên bản
                                                <div class="item-footer">Version</div>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!-- End -->
                    </div>


                    <div class="dialog dialog-wrap dialog-pin-code-confirm">
                        <div class="dialog-padding">
                            <div class="dialog dialog-inside">
                                <div class="dialog-inner" style="padding-bottom: 0;">
                                    <div class="dialog-title">Bảo mật</div>
                                    <div class="dialog-text" style="width: 100%; user-select: initial; text-align: center;">Cập nhật mã PIN</div>
                                    <br>
                                    <div class="list media-list" style="margin-left: -15px; margin-right: -15px; margin-bottom: 0; margin-top: 0; text-align: left;">
                                        <ul>
                                            <li class="item-content item-input">
                                                <div class="item-media"><i class="icon f7-icons text-color-default">pencil_ellipsis_rectangle</i></div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Mã pin (*)</div>
                                                    <div class="item-input-wrap">
                                                        <input class="field" name="PinCode" type="password" pattern="[0-9]*" inputmode="numeric" maxlength="4" placeholder="nhập mã PIN">
                                                        <span class="input-clear-button"></span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="dialog-buttons">
                                    <span class="dialog-button color-red closeBtn" (click)="processor.closePinCodeConfig($event)">Đóng</span>
                                    <span class="dialog-button createReferenceChatRoomBtn" (click)="processor.onPinCodeConfirm($event)">Xác nhận</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="dialog dialog-wrap" id="custom-list-link-dialog">
                        <div class="dialog-padding">
                            <div class="dialog dialog-inside">
                                <div class="dialog-inner" style="padding-bottom: 0;">
                                    <div class="dialog-title">Bảo mật</div>
                                    <div class="dialog-text" style="width: 100%; user-select: initial; text-align: center;">Cập nhật mã PIN</div>
                                    <br>
                                    <div class="list media-list" style="margin-left: -15px; margin-right: -15px; margin-bottom: 0; margin-top: 0; text-align: left;">
                                        <ul>
                                            <li class="item-content item-input">
                                                <div class="item-media"><i class="icon f7-icons text-color-default">pencil_ellipsis_rectangle</i></div>
                                                <div class="item-inner">
                                                    <div class="item-title item-label">Mã pin (*)</div>
                                                    <div class="item-input-wrap">
                                                        <input class="field" name="PinCode" type="password" pattern="[0-9]*" inputmode="numeric" maxlength="4" placeholder="nhập mã PIN">
                                                        <span class="input-clear-button"></span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="dialog-buttons">
                                    <span class="dialog-button color-red closeBtn" (click)="processor.closePinCodeConfig($event)">Đóng</span>
                                    <span class="dialog-button createReferenceChatRoomBtn" (click)="processor.onPinCodeConfirm($event)">Xác nhận</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Right panel with reveal effect-->
        <div class="panel panel-right panel-reveal theme-dark">
            <div class="view">
                <div class="page">
                    <div class="navbar">
                        <div class="navbar-bg"></div>
                        <div class="navbar-inner">
                            <div class="title">Right Panel</div>
                        </div>
                    </div>
                    <div class="page-content">
                        <div class="block">Right panel content goes here</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- buffer area -->
        <div class="list media-list" id="buffer-area">
            <ul>

            </ul>
        </div>

        <!-- Views/Tabs container -->
        <div class="views tabs safe-areas">
            <!-- Tabbar for switching views-tabs -->
            <div class="toolbar toolbar-bottom tabbar-labels">
                <div class="toolbar-inner">
                    <a *ngIf="!processor.isDesktop || true" class="tab-link panel-open link">
                        <i class="icon f7-icons if-not-md-x if-active">bars_fill</i>
                        <i class="icon f7-icons if-not-md-x if-not-active">bars</i>
                        <span class="tabbar-label">Menu</span>
                    </a>
                    <a href="#view-notifications" class="tab-link tab-link-active">
                        <i class="icon f7-icons if-not-md-x if-active">bell_fill<span *ngIf="rootServices.homeBadge > 0" class="badge color-red">{{rootServices.homeBadge}}</span></i>
                        <i class="icon f7-icons if-not-md-x if-not-active">bell<span *ngIf="rootServices.homeBadge > 0" class="badge color-red">{{rootServices.homeBadge}}</span></i>
                        <span class="tabbar-label">Tin nhắn</span>
                    </a>
                    <a href="#view-helpdesk" class="tab-link helpdesk">
                        <i class="icon f7-icons if-not-md-x if-active">tickets_fill<span *ngIf="rootServices.helpdeskBadge > 0" class="badge color-red">{{rootServices.helpdeskBadge}}</span></i>
                        <i class="icon f7-icons if-not-md-x if-not-active">tickets<span *ngIf="rootServices.helpdeskBadge > 0" class="badge color-red">{{rootServices.helpdeskBadge}}</span></i>
                        <span class="tabbar-label">Tickets</span>
                    </a>
                    <!-- <a *ngIf="isDesktop" href="#view-dialpad" class="tab-link">
                      <i class="icon f7-icons if-not-md-x">phone_fill</i>
                      <span class="tabbar-label">call</span>
                  </a> -->
                    <a href="#view-workplace" class="tab-link workplace">
                        <i class="icon f7-icons if-not-md-x if-active">briefcase_fill<span *ngIf="rootServices.workplaceBadge > 0" class="badge color-red">{{rootServices.workplaceBadge}}</span></i>
                        <i class="icon f7-icons if-not-md-x if-not-active">briefcase<span *ngIf="rootServices.workplaceBadge > 0" class="badge color-red">{{rootServices.workplaceBadge}}</span></i>
                        <span class="tabbar-label">Thông tin</span>
                    </a>
                    <a href="#view-home" class="tab-link">
                        <i class="icon f7-icons if-not-md-x if-active">house_fill<span *ngIf="rootServices.settingsBadge > 0" class="badge color-red">{{rootServices.homeBadge}}</span></i>
                        <i class="icon f7-icons if-not-md-x if-not-active">house<span *ngIf="rootServices.settingsBadge > 0" class="badge color-red">{{rootServices.homeBadge}}</span></i>
                        <span class="tabbar-label">Trang chủ</span>
                    </a>
                    <!-- <a href="#view-catalog" class="tab-link">
          <i class="icon f7-icons if-not-md">square_list_fill</i>
          <i class="icon material-icons if-md">view_list</i>
          <span class="tabbar-label">danh bạ</span>
        </a> -->
                </div>
            </div>

            <!-- Your main view/tab, should have "view-main" class. It also has "tab-active" class -->
            <div id="view-index" class="view view-main view-init-x tab">

            </div>
            <div id="view-home" class="view view-main view-init-x tab" data-name="home" data-url="/home">

            </div>

            <!-- Notificaitons View -->
            <div id="view-notifications" class="view view-init-x tab tab-active" data-name="notifications" data-url="/notifications">
                <!-- Catalog page will be loaded here dynamically from /catalog/ route -->
            </div>

            <!-- Helpdesk View -->
            <div id="view-helpdesk" class="view view-init-x tab" data-name="helpdesk" data-url="/helpdesk">
                <!-- Settings page will be loaded here dynamically from /settings/ route -->
            </div>

            <!-- Workplace View -->
            <div id="view-workplace" class="view view-init-x tab" data-name="workplace" data-url="/workplace">
                <!-- Settings page will be loaded here dynamically from /settings/ route -->
            </div>

            <!-- Settings View
          <div id="view-settings" class="view view-init-x tab" data-name="settings" data-url="/settings">
          </div> -->

            <!-- Settings View -->
            <div id="view-dialpad" class="view view-init-x tab" data-name="dialpad" data-url="/dialpad">
                <!-- Settings page will be loaded here dynamically from /settings/ route -->
            </div>

        </div>

        <!-- Popup -->
        <div class="popup" id="my-popup">
            <div class="view">
                <div class="page">
                    <div class="navbar">
                        <div class="navbar-bg"></div>
                        <div class="navbar-inner">
                            <div class="title">Popup</div>
                            <div class="right">
                                <a href="#" class="link popup-close">Close</a>
                            </div>
                        </div>
                    </div>
                    <div class="page-content">
                        <div class="block">
                            <p>Popup content goes here.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Login Screen -->
        <div class="login-screen" id="my-login-screen">
            <div class="view">
                <div class="page">
                    <div class="page-content login-screen-content">
                        <div class="login-screen-title">Login</div>
                        <div class="list">
                            <ul>
                                <li class="item-content item-input">
                                    <div class="item-inner">
                                        <div class="item-title item-label">Username</div>
                                        <div class="item-input-wrap">

                                            <input type="text" name="username" placeholder="Your username">
                                        </div>
                                    </div>
                                </li>
                                <li class="item-content item-input">
                                    <div class="item-inner">
                                        <div class="item-title item-label">Password</div>
                                        <div class="item-input-wrap">

                                            <input type="password" name="password" placeholder="Your password">
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="list">
                            <ul>
                                <li>
                                    <a href="#" class="item-link list-button login-button">Sign In</a>
                                </li>
                            </ul>
                            <div class="block-footer">Some text about login information.<br>Click "Sign In" to close Login Screen
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="fab color-orange" (click)="processor.openPreviewStack()" id="assistive-touch" style="position: fixed; z-index: 99999; top: calc(100% - 145px); left: calc(100% - 80px);" [ngStyle]="{'display': processor.previewStack.length > 0 ? 'block' : 'none'}">
            <a href="#">
                <span style="position: absolute; z-index: 999999999; right: 5px; top: 5px;" *ngIf="processor.previewStack.length > 0" class="badge color-red">{{processor.previewStack.length}}</span>
                <i class="icon f7-icons">rectangle_fill_on_rectangle_angled_fill</i>
            </a>
        </div>
    </div>
</ion-app>